const arrayToOptions = (arr) => {
  return arr.map(x => {return ({ key: x, text: x, value: x })})
}

export {arrayToOptions}
